import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gt-object-card gt-object-card--publications" }
const _hoisted_2 = { class: "gt-object-card__head" }
const _hoisted_3 = { class: "gt-object-card__image-wrapper" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "gt-object-card__body" }
const _hoisted_6 = { class: "gt-object-card__title" }
const _hoisted_7 = { class: "gt-object-card__bottom" }
const _hoisted_8 = { class: "gt-object-card__date" }
const _hoisted_9 = { class: "gt-object-card__buttons" }
const _hoisted_10 = { class: "gt-object-card__icon gt-space_ml gt-space_ml--2" }
const _hoisted_11 = { class: "gt-object-card__icon gt-space_ml gt-space_ml--2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_edit = _resolveComponent("i-edit")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_i_arrow_right = _resolveComponent("i-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "gt-object-card__image",
          src: $props.publication.image.file,
          alt: $props.publication.image.title
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", {
        class: "gt-object-card__status",
        style: _normalizeStyle({ backgroundColor: $props.colors[$props.publication?.status].color })
      }, [
        _createElementVNode("span", null, _toDisplayString($props.statuses[$props.publication?.status]), 1)
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString($props.publication.title), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString($setup.publishedAt), 1),
      _createElementVNode("div", _hoisted_9, [
        ($props.updatePageLink)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "gt-object-card__more-btn ds-link gt-space_mr gt-space_mr--5",
              to: { name: $props.updatePageLink, params: { id: $setup.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString($setup.$t('Edit')), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_i_edit)
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          class: "gt-object-card__more-btn ds-link",
          to: { name: $props.detailsPageLink, params: { id: $setup.id } }
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString($setup.$t('Details')), 1),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_i_arrow_right)
            ])
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}